module.exports = __webpack_public_path__ + "static/media/dummy.fe82902e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dummy.jpg
// module id = 560
// module chunks = 0